//можно почитать: https://learn.javascript.ru/js-animation

export function animate(options, cancelationToken) {
    return new Promise(function(resolve, reject) {
        var start = performance.now();
        var requestId;

        cancelationToken.cancel = function() { 
          cancelAnimationFrame(requestId);
          reject('cancelled');
        };

        requestAnimationFrame(function animate(time) {
            // timeFraction от 0 до 1
            var timeFraction = (time - start) / options.duration;
            if (timeFraction > 1) timeFraction = 1;

            // текущее состояние анимации
            var progress = options.timing(timeFraction)

            options.draw(progress);

            if (timeFraction < 1) {
                requestId = requestAnimationFrame(animate);
            }
            else {
                resolve();
            }

        });
    })
}


/** WEBPACK FOOTER **
 ** ./src/components/Animations/animate.js
 **/